import { render, staticRenderFns } from "./editShops.vue?vue&type=template&id=47a81c1a"
import script from "./editShops.vue?vue&type=script&lang=js"
export * from "./editShops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports